/* eslint-disable import/no-anonymous-default-export */
const initialState = {
  y: window.innerHeight / 2,
  r: 0,
};

// Helper function to detect if device has touch support (mobile)
const isMobileDevice = () => {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
};

// Define jump heights for different devices
const MOBILE_JUMP_HEIGHT = 60;
const DESKTOP_JUMP_HEIGHT = 60;

export default (state = initialState, { type, source } = {}) => {
  const jumpHeight = isMobileDevice() ? MOBILE_JUMP_HEIGHT : DESKTOP_JUMP_HEIGHT;

  switch (type) {
    case "FLY":
      return { ...state, y: state.y - jumpHeight, r: -30 };
    case "FALL":
      return { ...state, y: state.y + 20, r: 0 };
    case "GAME_OVER":
      return initialState;
    default:
      return state;
  }
};
